import { PageId } from 'constants/pages'

export const enum PageIdWoofzOffer165 {
  SUBSCRIPTIONS_OFFER1_65 = PageId.SUBSCRIPTIONS_OFFER1_65,
  CHAT_UPSELL_OFFER1_65 = PageId.CHAT_UPSELL_OFFER1_65,
  UPSELL_OFFER1_65 = PageId.UPSELL_OFFER1_65,
  DOWNLOAD_OFFER1_65 = PageId.DOWNLOAD_OFFER1_65,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
